import { BorderedCard } from 'fmc-digital-common';
import { Skeleton, VStack } from 'native-base';
import React, { memo } from 'react';
import NewLoanInProgressHeader from '../NewLoanInProgressHeader';
const LoanOverviewSkeleton = ({
  dataTestID
}) => {
  return /*#__PURE__*/React.createElement(BorderedCard, {
    border: "border.primary",
    bgColor: "white.500",
    px: "4",
    py: "2",
    testID: dataTestID,
    marginBottom: 8,
    flex: 1
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 6
  }, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
    header: "Loan Summary"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    size: "5",
    w: "auto",
    h: "4",
    startColor: "#D8E3F8",
    borderRadius: "4"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    size: "5",
    w: "auto",
    h: "4",
    startColor: "#D8E3F8",
    borderRadius: "4"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    size: "5",
    w: "auto",
    h: "4",
    startColor: "#D8E3F8",
    borderRadius: "4"
  })));
};
export default /*#__PURE__*/memo(LoanOverviewSkeleton);
//# sourceMappingURL=index.js.map